import React from 'react'

import contactBg from '../images/gain-bottom-shapes.svg'

function Contact() {
	return (
		<section
			className='contact'
			id='contacto'
			style={{ backgroundImage: `url(${contactBg})` }}
			data-aos='fade-up'
			data-aos-offset='600'>
			<h2 className='contact__title'>Contacto</h2>
			<div className='contact__content'>
				<form className='contact-form'>
					<input
						className='field'
						type='text'
						name='name'
						aria-labelledby='Nombre'
						placeholder='Nombre'
					/>
					<input
						className='field'
						type='email'
						name='email'
						aria-labelledby='Email'
						placeholder='Email'
					/>
					<textarea
						name='message'
						className='field textarea'
						aria-labelledby='Mensaje'
						placeholder='Mensaje'></textarea>
					<button className='submit' type='submit'>
						Enviar
					</button>
				</form>

				<div className='contact-info'>
					<p>
						<span>Dirección: </span>
						<a
							href='https://www.google.com/maps/place/Rufino+Ortega+123,+Mendoza'
							target='_blank'
							rel='noopener noreferrer'>
							Rufino Ortega 123 - Ciudad - Mendoza
						</a>
					</p>
					<p>
						<span>Telefono: </span>
						<a href='tel:+549261555999'>+54 9 261 555 999</a>
					</p>
					<p>
						<span>Email: </span>
						<a href='mailto:info@gain.com'>info@gain.com</a>
					</p>
				</div>
			</div>
		</section>
	)
}

export default Contact
